import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";
import {
  InfoSection,
  About,
  Navbar,
  Contact,
  Sidebar,
  Footer,
  Services,
  Skills,
  BusinessSkills,
  Experience,
  Projects,
  ProjectDetail,
  Certifications,
  TravelGallery,
  GalleryPage,
} from "../src/components";
import ScrollToTop from "../src/components/ScrollToTop";
import { homeObjOne, homeObj2 } from "../src/Data";
import { ThemeStore } from "../src/contexts/ThemeContext";
import Theme from "./Theme";

function Home() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const desc =
    "Enes Güngör — Fullstack Product Engineer with 6+ years shipping web & mobile products from zero to production. Projects, experience, certifications and contact.";

  return (
    <>
      <Helmet>
        <title>Enes Güngör — Fullstack Product Engineer</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href="https://enesgungor.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Enes Güngör" />
        <meta
          property="og:title"
          content="Enes Güngör — Fullstack Product Engineer"
        />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content="https://enesgungor.com/" />
        <meta
          property="og:image"
          content="https://enesgungor.com/og-image.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Enes Güngör — Fullstack Product Engineer"
        />
        <meta name="twitter:description" content={desc} />
        <meta
          name="twitter:image"
          content="https://enesgungor.com/og-image.jpg"
        />
      </Helmet>
      <h1
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Enes Güngör — Fullstack Product Engineer, Web &amp; Mobile Developer
      </h1>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />

      <InfoSection {...homeObjOne} />
      <About {...homeObj2} />
      <Skills />
      <BusinessSkills />
      <Experience />
      <Projects />
      <Certifications />
      <TravelGallery />
      <Services />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <ThemeStore>
      <Theme>
        <Router>
          <ScrollToTop />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/gallery" component={GalleryPage} />
            <Route path="/project/:slug" component={ProjectDetail} />
          </Switch>
        </Router>
      </Theme>
    </ThemeStore>
  );
}

export default App;
